export const SET_SERVICE_INDICATOR = "SET_SERVICE_INDICATOR";

export const setServiceIndicatorCount = (serviceIndicatorCount) => {
  return (dispatch) => {
    dispatch({
      type: SET_SERVICE_INDICATOR,
      payload: serviceIndicatorCount,
    });
  };
};
